import { useState, useEffect } from "react";
import axios from "axios";

const ApiURL = process.env.REACT_APP_API_URL;

const useBusinessHours = () => {
  const [hours, setHours] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await axios.get(`${ApiURL}/settings`);
        const { activeSeason, hours } = res.data;
        setHours(hours[activeSeason]);
      } catch {
        setHours({ weekdays: "8:00 - 12:00 y 15:00 - 19:00", saturday: "8:00 - 12:00" });
      }
    };
    fetchSettings();
  }, []);

  return hours;
};

export default useBusinessHours;